<template>
  <form class="py-5">
    <fieldset class="space-y-5">
      <slot />
    </fieldset>
  </form>
</template>
